<template>
	<div class="info-panel">
		<div class="policy-info">
			<Button class="policy-info-btn" :action="displayPolicy">
				{{ ui.policy.button_label }}
			</Button>
		</div>
		<div class="about-game">
			<Button class="about-game-btn" :action="displayAboutInfo">
				{{ ui.about.button_label }}
			</Button>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Button from '@/components/base/Button';

export default {
	name: 'InfoPanel',
	components: {
		Button,
	},
	computed: {
		...mapState({
			ui: (state) => state.global.api.data.ui.info,
		}),
	},
	methods: {
		...mapActions({
			activateModal: "global/modal/activate",
		}),
		displayPolicy() {
			this.activateModal({
				component: 'PolicyModal',
				class: "policy",
			});
			this.$store.dispatch("sound/fx/play", { id: "whoosh_generic" });
			this.$store.dispatch("global/analytics/trackEvent", { ec: "PlanDetails", el: this.$store.state.game.rounds.index, ea: 'Click' });
		},
		displayAboutInfo() {
			this.activateModal({
				component: 'AboutModal',
				class: "about",
			});
			this.$store.dispatch("sound/fx/play", { id: "whoosh_generic" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.info-panel {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: $info-panel-height-mobile;
		color: black;
		font-size: $font-size-md;
		z-index: $z-top;

		@include desktop {
			width: $info-panel-height-mobile;
			height: 100%;
			writing-mode: vertical-rl;
			text-orientation: mixed;
		}

		@include desktop-sm { padding-top: $header-height-desktop; }
	}

	.policy-info,
	.about-game {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50%;
		background: linear-gradient(90deg, $alt-color-light, $alt-color-extra-light, $alt-color);
		border-top: $border-width-md solid black;
		text-transform: uppercase;

		@include desktop {
			width: 100%;
			height: 50%;
			border-top-width: 0;
			border-bottom-width: 0;
			background: linear-gradient(0deg, $alt-color-light, $alt-color-extra-light, $alt-color);
		}
	}

	.policy-info {
		border-right-width: $border-width-sm;

		@include desktop {
			border-right: solid $border-width-md;
			border-bottom: solid $border-width-sm;
		}
	}

	.policy-info-btn,
	.about-game-btn {
		border: none;
		padding: 0;
		margin: 0;

		@include desktop-sm { font-size: $font-size-sm; }
	}

	.about-game {
		border-left: solid $border-width-md;

		@include desktop {
			border-top: solid $border-width-sm;
			border-right: solid $border-width-md;
			border-left: none;
		}
	}
</style>
